/* eslint-disable linebreak-style */
/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
// import { makeStyles } from '@material-ui/core/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ImportExportIcon from '@material-ui/icons/ImportExport';



const styles = () => ({
  paddingCheckbox: {
    padding: '0 12px',
  },
  actionsColumn: {
    width: 220,
    textAlign: 'center',
  },
});


class DataTable extends React.Component {
  state = {
    page: 0,
    rowsPerPage: this.props.outRowsPerPage ? this.props.outRowsPerPage : 10,
    reverseItens: false,
    alphabeticalSort: false,
    Titletable: ''
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  Resetsort = (column) => {
    if (this.state.reverseItens === false) {
      this.setState({ alphabeticalSort: true, reverseItens: true, Titletable: column.name })
    } else {
      this.setState({ alphabeticalSort: false, reverseItens: false })
    }
  }
  render() {
    const {
      rows, columns, actions, loading, independentActions, pagination, align, disableHover, noResultsText, outRowsPerPage
    } = this.props;
    const { page, rowsPerPage } = this.state;

    const { classes } = this.props;

    const rowsLenght = rows == undefined ? 0 : rows.length

    let emptyMessage = null;
    if (!rowsLenght && !loading) {
      emptyMessage = (
        <TableRow>
          <TableCell colSpan={columns.length + 1}>
            <Typography variant="body1" align="center">
              {noResultsText || 'Nenhuma informação cadastrada'}
            </Typography>
          </TableCell>
        </TableRow>
      );
    }

    const collator = new Intl.Collator('pt-Br', { numeric: true, sensitivity: 'base' });
    let RowsFilter = this.state.alphabeticalSort === true ? [...rows].sort((a, b) => {
      return collator.compare(a[this.state.Titletable], b[this.state.Titletable]);
    }) : rows;

    let visibleRows = this.state.reverseItens ? rows.reverse() : rows;

    // RowsFilter = this.state.Titletable == 'name' ? RowsFilter.reverse() : RowsFilter

    if (pagination) {
      RowsFilter = rows.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage);
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell align={align || column.align} key={column.name} style={{ padding: '12px' }}>
                {
                  <TableSortLabel
                    IconComponent={ImportExportIcon}
                    onClick={() => this.Resetsort(column)}
                  >
                    {column.label}
                  </TableSortLabel>
                }
              </TableCell>
            ))}
            {independentActions || actions ? (
              <TableCell className={[classes.actionsColumn, classes.paddingCheckbox]}>
                Ações
              </TableCell>
            ) : null}
          </TableRow>
          {loading ? (
            <tr>
              <TableCell padding="none" colSpan={columns.length + 1}>
                <LinearProgress />
              </TableCell>
            </tr>
          ) : null}
        </TableHead>

        <TableBody>
          {emptyMessage ||
            RowsFilter.map((row, index) => {
              const rowActions = independentActions ? row.actions : actions;
              return (
                <TableRow key={row.id || index} hover={!disableHover} style={{ height: '48px' }}>
                  {columns.map(column => (
                    <TableCell key={column.name} align={align || column.align} className={classes.paddingCheckbox} style={column.styles}>
                      {
                        row[column.name] || '—'
                      }
                    </TableCell>
                  ))}
                  {rowActions ? (
                    <TableCell className={[rowActions && classes.actionsColumn, classes.paddingCheckbox]}>
                      {rowActions.map(action => (
                        <Tooltip key={action.name} title={action.iconColor && row[action.iconColor.condition] === true ? 'Cancelar desligamento' : action.name} placement="top-center">
                          <IconButton
                            onClick={() =>
                              action.onClick({
                                ...row,
                                name: row[columns[0].name],
                              })
                            }
                            // color="primary"
                            style={{ color: action.iconColor && row[action.iconColor.condition] === true ? action.iconColor.color : '#537ccd' }}
                          >
                            <action.icon />
                          </IconButton>
                        </Tooltip>
                      ))}
                    </TableCell>
                  ) : null}
                </TableRow>
              );
            })}
        </TableBody>

        {pagination ? (
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={columns.length + 1}
                rowsPerPageOptions={[outRowsPerPage || 10, 15, 25, 50]}
                count={rows.length}
                rowsPerPage={outRowsPerPage ? outRowsPerPage : rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                labelRowsPerPage="Itens por página"
              />
            </TableRow>
          </TableFooter>
        ) : null}
      </Table>
    );
  }
}

DataTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    align: PropTypes.string,
    styles: PropTypes.object,
  })).isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired,
  })),
  independentActions: PropTypes.bool,
  pagination: PropTypes.bool,
  loading: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  noResultsText: PropTypes.string,
};

DataTable.defaultProps = {
  actions: null,
  independentActions: false,
  pagination: true,
  loading: false,
};

export default withStyles(styles)(DataTable);
